import './rating.css'
import './static/wreath.svg'
import './static/star-empty.svg'
import './static/star-half.svg'
import './static/star-full.svg'
